import { useIsMutating, useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTripMerge } from '../../services/TripsService';
import { TripMergeSettings } from '../../types/Trips';

const TRIP_MERGE_REFETCH_INTERVAL_MS = 5000;

function useGetTripMerge(fleetId: string, enabled = true): UseQueryResult<TripMergeSettings> {
  const isPatchingTripMerge = useIsMutating({ mutationKey: ['patch-trip-merge'] }) > 0;

  return useQuery(
    ['trip-merge', fleetId],
    async (): Promise<TripMergeSettings> => getTripMerge(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: isPatchingTripMerge ? false : TRIP_MERGE_REFETCH_INTERVAL_MS,
      enabled: !!fleetId && enabled,
    },
  );
}

export default useGetTripMerge;
